import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';
import isNilValue from 'utils/predicates/any/isNilValue.util';
import { isValidId } from 'utils/predicates/fields.util';
import isArrayIndex from 'utils/predicates/number/isArrayIndex.util';

const L = logger('fromKpiSelectionToDto'); // eslint-disable-line no-unused-vars

const fromKpiSelectionToDto = (item) => {
  if (isNilValue(item)) return item;

  const { toPosition, stylistId, metricKey } = item;

  if (isValidId(stylistId)) return { stylist: stylistId, metric_key: fromAnyToString(metricKey) };
  if (isArrayIndex(toPosition)) return { to_position: toPosition };

  return {
    id: item?.id,
    order: item?.order,
    label: item?.label,
    metric_type: item?.metricType,
    metric_key: item?.metricKey,
    stylist: item?.stylistId,
    category: item?.category,
    salon: item?.salonId,
  };
};

export default fromKpiSelectionToDto;
